import {
	GridColumnProps,
	GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import i18n from "../../../../i18n";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell } from "ui/grid/GridCommandCell";
import { CLASSNAME } from "utils/constant";
import { FC } from "react";
import { formatNorwegianNumber } from "utils/helper";
import { calculateFieldStats } from "utils/statUtils";
import React from "react";

let t = i18n.t;

export const PurchaseStatisticColumnItem = (data: any[] = []) => {
	const gridItems: GridColumnProps[] = [
		{
			field: "productName",
			title: t("Product"),
			cells: { data: (props) => <CellPopover {...props} /> },
			className: `no-border`,
		},

		{
			field: "netLiveWeightKg",
			title: t("Weight"),
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kg"} style={{}} />,
				headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (props) => (
					<td className={`${CLASSNAME.TableNumeric} no-border td-bold`}>
						{`${formatNorwegianNumber(calculateFieldStats(data, "netLiveWeightKg").sum, 2, 2)} kg`}
					</td>
				),
				groupFooter: (props) => {
					let data = props.dataItem.aggregates.netLiveWeightKg;
					if (props.dataItem?.field === "group1") {
						return <td className={`no-border td-bold`}></td>;
					}
					return (
						<td className={`${CLASSNAME.TableNumeric} no-border td-bold`}>
							<div style={{ marginTop: "20px" }}>
								{`${formatNorwegianNumber(data.sum, 2, 2)} kg`}
							</div>
						</td>
					);
				},
				group: {
					groupFooter: (props) => {
						let data = props.dataItem.aggregates.netLiveWeightKg;
						return (
							<td className={`${CLASSNAME.TableNumeric} no-border td-bold`}>
								{`${formatNorwegianNumber(data.sum, 2, 2)} kg`}
							</td>
						);
					},
				},
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "averagePrice",
			title: t("AveragePrice"),
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "amount",
			title: t("Amount"),
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (props) => (
					<td className={`${CLASSNAME.TableNumeric} no-border td-bold`}>
						{`${formatNorwegianNumber(calculateFieldStats(data, "amount").sum, 2, 2)} kr`}
					</td>
				),
				groupFooter: (props) => {
					const groupData = props.dataItem.aggregates.amount;
					if (props.dataItem?.field === "group1") {
						return <td className={`no-border td-bold`}></td>;
					}
					return (
						<td className={`${CLASSNAME.TableNumeric} no-border td-bold`}>
							<div style={{ marginTop: "20px" }}>
								{`${formatNorwegianNumber(groupData.sum, 2, 2)} kr`}
							</div>
						</td>
					);
				},
				group: {
					groupFooter: (props) => {
						const groupData = props.dataItem.aggregates.amount;
						return (
							<td className={`${CLASSNAME.TableNumeric} no-border td-bold`}>
								{`${formatNorwegianNumber(groupData.sum, 2, 2)} kr`}
							</td>
						);
					},
				},
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "",
			title: "",
			width: "50px",
			className: `no-border`,
		},
	];
	return gridItems;
};

export const NumericalHeader: FC<
	GridHeaderCellProps & { style?: React.CSSProperties } & any
> = (props) => {
	return (
		<th style={{ ...props.style, textAlign: "end", paddingRight: "10px" }}>
			{props.title}
		</th>
	);
};
